import {emotionStyled, tokens} from '@packages/utilities/styled';

import {RowItemActiveSelectors} from '../RowItem.styles';
import {RowItemAction} from '../RowItemActions';

// We are replicating an IconButton for Chevron to preserve space.
export const RowItemChevronView = emotionStyled('div')(
  {
    opacity: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    pointerEvents: 'none', // pass clicks through to the RowItem handler
    padding: tokens.ui.iconButton.padding.comfortable,
  },
  {
    componentName: 'RowItemChevron',
    variants: {
      shouldHideOnActive: {
        true: {
          [RowItemActiveSelectors(`:has(${RowItemAction})`)]: {
            display: 'none',
          },
        },
      },
      dragState: {
        true: {
          display: 'none',
        },
      },
      isDisabled: {
        true: {
          opacity: tokens.opacities.disabled,
        },
      },
    },
  }
);
